import React from 'react';
import { GridItem } from '@chakra-ui/react';
import GridRow from '../common/GridRow';
import LogoPage from '../common/LogoPage';
import GameSettings from './settings/GameSettings';
import LeaveButton from './LeaveButton';
import LobbyButtons from './LobbyButtons';
import PlayerList from '../common/players/PlayerList';
import RoomCode from './RoomCode';

export default function Lobby(props) {
  return (
    <LogoPage id="lobby">
      <LeaveButton onConfirm={() => props.leaveRoom(props.playerID, props.roomID)} />
      {<LobbyButtons isAdmin={props.isAdmin} modals={props.modals} />}
      <GridRow cols={4} gap={8} m={4}>
        <GridItem>
          <RoomCode code={props.room.roomCode} toast={props.toast} />
          <PlayerList currentPlayerID={props.playerID} {...props} />
        </GridItem>
        <GridItem colSpan={3}>
          <GameSettings {...props} />
        </GridItem>
      </GridRow>
    </LogoPage>
  );
}
